<template>
    <div id="addProprietor">
      <search-company ref="searchInnerCompany" @confirm="confirmCompanySelect" v-show="modeType && !isOwnerForm"></search-company>
      <a-form :form="ownerForm" layout="vertical" v-show="!modeType || isOwnerForm">
        <div class="formDiv">
            <a-row :gutter="20">
              <a-col :span="16">
                <a-form-item class="required" :label="$t('proprietor.proprietorModal.companyName')">
                  <pt-input @click="addCompany" v-decorator="['companyName',{rules: [
                {required: true,message: $t('proprietor.proprietorModal.companyNameTip'),},
                {min: 2, max: 128, message: $t('proprietor.proprietorModal.textSmallLength')}
              ],}]" :placeholder="$t('proprietor.proprietorModal.companyNameTip')"></pt-input>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item class="required" :label="$t('proprietor.proprietorModal.companyNameCN')">
                  <pt-input  v-decorator="['companySortNameCn',{rules: [
                {required: true,message: $t('proprietor.proprietorModal.companyNameCNTip'),},
                {min: 2, max: 128, message: $t('proprietor.proprietorModal.textSmallLength')}
              ],}]" :placeholder="$t('proprietor.proprietorModal.companyNameCNTip')"></pt-input>
                </a-form-item>
              </a-col>

            </a-row>
            <a-row :gutter="20">
              <!--<a-col :span="8">-->
                <!--<a-form-item :label="$t('proprietor.proprietorModal.companyNameEN')">-->
                  <!--<pt-input v-decorator="['companySortNameEn',{rules: [-->
                <!--{min: 2, max: 128, message: $t('proprietor.proprietorModal.textSmallLength')}-->
              <!--],}]" :placeholder="$t('proprietor.proprietorModal.companyNameENTip')"></pt-input>-->
                <!--</a-form-item>-->
              <!--</a-col>-->
              <a-col :span="8">
                <a-form-item class="required" :label="$t('proprietor.proprietorModal.typeLabel')">
                  <pt-select  v-decorator="['type',{rules: [
                {required: true,message: $t('proprietor.proprietorModal.typeTip'),},
                  ],}]" :placeholder="$t('proprietor.proprietorModal.typeTip')">
                    <a-select-option :value="1">{{$t('proprietor.proprietorModal.secondLandlord')}}</a-select-option>
                    <a-select-option :value="2">{{$t('proprietor.proprietorModal.developers')}}</a-select-option>
                  </pt-select>
                </a-form-item>
              </a-col>
<!--              <a-col :span="8">-->
<!--                <a-form-item :label="$t('proprietor.proprietorModal.website')">-->
<!--                  <pt-input v-decorator="['url',{rules: [-->
<!--                  {min: 2, max: 256, message: $t('proprietor.proprietorModal.textMaxLength')}-->
<!--                ],}]" :placeholder="$t('proprietor.proprietorModal.websiteTip')"></pt-input>-->
<!--                </a-form-item>-->
<!--              </a-col>-->

            </a-row>
<!--            <a-row>-->
<!--              <a-col :span="24">-->
<!--                <a-form-item class="required" :label="$t('proprietor.proprietorModal.project')">-->
<!--                  <a-select :placeholder="$t('proprietor.proprietorModal.projectTip')" @dropdownVisibleChange="openSelectMansion" v-decorator="['mansionIds',{rules: [-->
<!--                {required: true,message: $t('proprietor.proprietorModal.mansionTip'),},-->
<!--                  ],}]"  mode="multiple" :maxTagCount="3" :label="$t('proprietor.proprietorModal.project')" @change="mansionChange" :open="false">-->
<!--                    <a-select-option v-for="(mansion,index) in mansionList":key="index" :value="mansion.id">{{mansion.name}}</a-select-option>-->
<!--                  </a-select>-->
<!--                </a-form-item>-->
<!--                <div class="addProjectBtn" @click="openSelectMansion">-->
<!--                  <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>-->
<!--                </div>-->
<!--              </a-col>-->
<!--            </a-row>-->
        </div>
        <div class="project_div" v-if="!ownerId && showProject">
          <div class="project_top">
            <div class="expandTitleRow">
              <div class="circleYellow"></div>
              <div class="expandTitle">{{$t('proprietor.proprietorModal.project')}}</div>
             <!-- <div class="required"><span>*</span></div>-->
              <div class="mul_select">{{$t('proprietor.proprietorModal.mulSelect')}}</div>
            </div>
            <a-button size="small" @click="openSelectMansion">
              <pt-icon type="icon-zengjia" />
              {{$t('proprietor.proprietorModal.addProject')}}
            </a-button>
          </div>
          <div class="project_item_div">
            <div class="empty_div" v-if="mansionList.length == 0">
              <pt-empty :description="$t('proprietor.proprietorModal.empty')"></pt-empty>
            </div>
            <div class="item" v-if="mansionList.length > 0">
                <a-row :gutter="20" class="project_header">
                  <a-col :span="7">{{$t('proprietor.proprietorModal.projectName')}}</a-col>
                  <a-col :span="8">{{$t('proprietor.importantLeavel')}}</a-col>
                  <a-col :span="8">{{$t('proprietor.proprietorModal.level')}}</a-col>
                </a-row>
                <a-row :gutter="20" v-for="(item,index) in mansionIds" :key="index" class="project_item">
                  <a-col :span="7" class="project_name">
                    {{item.name}}
                  </a-col>
                  <a-col :span="8">
                      <pt-select v-model="item.importantLeavel" :disabled="true" :allow-clear="false">
                        <a-select-option v-for="(item,index) in importantLeavelList" :key="index" :value="item">{{item}}</a-select-option>
                      </pt-select>
                  </a-col>
                  <a-col :span="8">
                      <pt-select v-model="item.cooperationGrade" :allow-clear="false">
                        <a-select-option v-for="(grade,index) in gradeList" :key="index" :value="grade.wordKey">{{grade.wordValue}}</a-select-option>
                      </pt-select>
                  </a-col>
                  <a-col :span="1">
                    <pt-icon  @click.native="deleteSelect(item,index)" type="icon-tubiao"></pt-icon>
                  </a-col>
                </a-row>

            </div>
          </div>
        </div>
        <div v-if="ownerId == null">
          <div class="expandMoreBtn" v-if="!contactVisible" @click="toggleContact(true)">
            <pt-icon type="icon-zengjia" class="expandIcon"></pt-icon>
            <div class="expandMoreText">{{$t('track.trackModal.contactLabel')}}</div>
          </div>
          <div class="expandDiv" v-if="contactVisible">
            <div class="expandTitleRow">
              <div class="circleYellow"></div>
              <div class="expandTitle">{{$t('track.trackModal.contactLabel')}}</div>
            </div>
            <div class="expandMoreDiv">
              <div class="closeExpandBtn" @click="toggleContact(false)">
                <pt-icon type="icon-guanbi-copy" class="closeIcon"></pt-icon>
              </div>
              <a-row :gutter="10" v-if="contactList.length > 0">
                <a-col :span="3">
                  <div class="labelText">{{$t('proprietor.proprietorModal.name')}}<span style="font-size:14px;color:#f5222d;">*</span></div>
                </a-col>
                <a-col :span="7">
                  <div class="labelText">{{$t('proprietor.proprietorModal.manageProject')}}</div>
                </a-col>
                <a-col :span="4">
                  <div class="labelText">{{$t('proprietor.proprietorModal.job')}}</div>
                </a-col>
                <a-col :span="4">
                  <div class="labelText">{{$t('proprietor.proprietorModal.phone')}}</div>
                </a-col>
                <a-col :span="6">
                  <div class="labelText">{{$t('proprietor.proprietorModal.email')}}</div>
                </a-col>
              </a-row>
              <a-row :gutter="10" v-for="(item,index) in contactList" :key="index">
                <a-col :span="3">
                  <a-form-item>
                    <pt-input  v-decorator="[`linkmanVOList[${index}].name`,{rules: [
                  {required: true,message: $t('customer.customerModal.contactNameTip'),},
                ],}]" :placeholder="$t('track.trackModal.contactNameTip')"></pt-input>
                  </a-form-item>
                </a-col>
                <a-col :span="7">
                  <a-form-item>
                    <pt-select v-decorator="[`linkmanVOList[${index}].mansionIds`,{rules: [

                  ],}]" :maxTagCount="1"  mode="multiple" :placeholder="$t('proprietor.proprietorModal.manageProjectTip')">
                      <a-select-option v-for="(mansion,index) in mansionList":key="index" :value="mansion.id">{{mansion.name}}</a-select-option>
                    </pt-select>
                  </a-form-item>
                </a-col>
                <a-col :span="4">
                  <a-form-item>
                    <a-input  v-decorator="[`linkmanVOList[${index}].job`,{rules: [
                 {min: 2, max: 64, message: $t('customer.customerModal.textMinLength'), trigger: 'blur'},
                ],}]" :placeholder="$t('track.trackModal.positionTip')"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="4">
                  <a-form-item>
                    <a-input  v-decorator="[`linkmanVOList[${index}].phone`,{rules: [
                  {min: 2, max: 64, message: $t('customer.customerModal.textMinLength'), trigger: 'blur'},
                ],}]" :placeholder="$t('track.trackModal.contactNum')"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="5">
                  <a-form-item>
                    <a-input  v-decorator="[`linkmanVOList[${index}].email`,{rules: [
                  {
                    type: 'email',
                    message:$t('customer.customerModal.emailErrorTip'),
                  },
                  {min: 2, max: 256, message: $t('customer.customerModal.textMaxLength'), trigger: 'blur'},
                ],}]" :placeholder="$t('track.trackModal.contactEmail')">
                    </a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="1">
                  <div class="deleteBtn" v-if="index !== 0" @click="deleteContactRow(index)">
                    <pt-icon type="icon-tubiao" class="delIcon"></pt-icon>
                  </div>
                </a-col>
              </a-row>
              <a-row>
                <div class="addContactBtn" @click="addContactRow">
                  <pt-icon type="icon-zengjia" class="addIcon"></pt-icon>
                </div>
              </a-row>
            </div>
          </div>
        </div>
      </a-form>
      <pt-modal :title="$t('proprietor.selectMansionModal.title')" :visible="selectModel.visable" :loading="selectModel.loading"
                @ok="submitEvent" @cancel="cancelEvent" :width="800">
        <div slot="content">
          <select-mansion :mansionList="mansionList" ref="selectMansion" @confirmSelect="confirmSelect"></select-mansion>
        </div>
      </pt-modal>
      <pt-modal :width="800" :title="$t('customer.searchCompanyModal.title')" :visible="searchModel.visible" :loading="searchModel.loading"
                @ok="submitCompanyEvent" @cancel="cancelCompanyEvent">
        <div slot="content">
          <search-company ref="searchCompany" @confirm="confirmCompanySelect"></search-company>
        </div>
      </pt-modal>
    </div>
</template>

<script>
  import PtModal from "../../../../components/modal/index";
  import SelectMansion from './selectMansion';
  import {insert,update,selectOne} from '@/api/database/owner'
  import {getDatadictChildsByPath} from '@/api/sys/datadict';
  import SearchCompany from '../../customer/module/searchCompany'

  export default {
    name: 'addProprietor',
    props:{
      ownerId: null,
      modeType:{ //true 为新增 false 为编辑
        default:true,
        type:Boolean
      },
      showProject:{
        type:Boolean,
        defautl:true,
      }
    },
    components:{
      SearchCompany,
      PtModal,
      SelectMansion,
    },
    data(){
      return{
        isOwnerForm:false,
        searchModel:{
          visible:false,
          loading:false,
        },
        contactVisible:false,
        ownerForm:this.$form.createForm(this,{}),
        isSecond: 2,
        contactList:[],
        selectModel:{
          visable:false,
          loading:false
        },
        mansionList:[],//选中楼宇的值
        mansionIds:[],//选择的ids
        importantLeavelList:['A','B','C','D'],
        fileDO:{
          id:"0"
        },
        ownerVO:{},
        gradeList:[],//合作等级
        mansionOptions:[],//项目选择器
      }
    },
    beforeCreate () {
      this.ownerForm = this.$form.createForm(this)
    },
    mounted(){
      this.$emit('input',this.$t('customer.searchCompanyModal.title'));
      this.init()
    },
    methods:{
      addCompany(){
        if(this.modeType){
          this.searchModel.visible = true;
        }else{
          this.searchModel.visible = true;
        }
      },
      submitCompanyEvent(){
        this.$refs.searchCompany.confirmSelect();
      },
      cancelCompanyEvent(){
        this.searchModel.visible = false;
      },
      confirmCompanySelect(company){
        this.ownerForm.setFieldsValue({
          companyName: company.name
        })
        if(this.modeType){
          this.isOwnerForm = true;
          this.cancelCompanyEvent();
        }else{
          this.cancelCompanyEvent();
        }
      },
      toggleContact(visible){
        this.contactVisible = visible;
        if(visible){
          this.addContactRow()
        }else{
          this.contactList = []
        }
      },
      mansionChange(value){
        for(var i = 0;i < this.mansionList.length;i++){
          let indexOf = value.indexOf(this.mansionList[i].id);
          if(indexOf == -1){
            this.mansionList.splice(i,1);
            i--;
          }
        }
        this.fillMansionOptions();
      },
      fillMansionOptions(){
        this.mansionOptions = [];
        this.mansionList.forEach(data=>{
          let mansionOption = {
            label:data.name,
            value:data.id
          }
          this.mansionOptions.push(mansionOption);
        })
      },
      getImageUrl(){
        let url = this.$util.getFileUrl(this.fileDO.id);
        return url;
      },
      onSuccess(file,fileId,number){
        this.fileDO = Object.assign(file,{id:fileId});
      },
      init(){
        this.queryGradeList();
        if(this.ownerId){
          this.queryDetail();
        }
      },
      queryGradeList(){
        let this_ = this
        getDatadictChildsByPath("system.business_key.cooperation_level_set").then(res=>{
          this_.gradeList = res.data
        })
      },
      queryDetail(){
        let this_ = this
        selectOne(this_.ownerId).then(res=>{
          if(res.code == 1){
              let temp = JSON.stringify(res.data)
            this_.ownerVO = JSON.parse(temp.replace(/\"~\"/g,null))
            this_.fillForm();
          }
        })
      },
      fillForm(){
        this.fileDO.id = this.ownerVO.logo;
        if(this.ownerVO.ownerMansionDOList){
          this.mansionList = [];
          this.mansionIds = [];
          this.ownerVO.ownerMansionDOList.forEach(data=>{
            var mansion = {
              id:data.mansionId,
              name:data.mansionName
            }
            this.mansionList.push(mansion);
            this.mansionIds.push(mansion.id);
            this.ownerVO["mansionIds"] = this.mansionIds;
          })
          this.fillMansionOptions();
        }
        if(this.ownerVO.linkmanVOList){
          this.ownerVO.linkmanVOList.forEach(data=>{
            let mansionIds = [];
            if(data.linkmanMansionDOList){
              data.linkmanMansionDOList.forEach(item=>{
                mansionIds.push(item.mansionId);
              })
              data["mansionIds"] = mansionIds;
            }
          })
          this.contactList = [];
          this.ownerVO.linkmanVOList.forEach((data,index)=>{
            this.contactList.push(index);
          })
        }
        setTimeout(()=>{
          this.ownerForm.setFieldsValue(this.ownerVO);
        },0)
      },
      deleteSelect(item,index){
        let delIndex = null;
        this.mansionList.forEach((data,mansionIndex)=>{
          if(data.id == item.mansionId){
            delIndex = mansionIndex
          }
        })
        if(delIndex != null){
          this.mansionList.splice(delIndex,1)
        }
        this.mansionIds.splice(index,1)
      },
      confirmSelect(mansionList){
        this.mansionList = mansionList;
        this.mansionIds = [];
        this.mansionList.forEach(item=>{
          this.mansionIds.push({mansionId:item.id,name:item.name,importantLeavel:'D',cooperationGrade:'class_E'});
        })
        this.fillMansionOptions();
        this.cancelEvent();
      },
      openSelectMansion(){
        this.selectModel.visable = true;
      },
      switchSelect(visible){
        this.isSecond = visible;
      },
      deleteContactRow(index){
        let keys = this.ownerForm.getFieldValue('linkmanVOList');
        this.ownerForm.setFieldsValue({
          linkmanVOList: keys.filter((item,i) => index !== i),
        })
        this.contactList.splice(index,1);
      },
      addContactRow(){
        var contactDO ={
          mansionIds : [],
        }
        this.contactList.push(contactDO);
      },
      submitEvent(){
        this.$refs.selectMansion.confirmSelect();
      },
      cancelEvent(){
        this.selectModel.visable = false;
      },
      submit(){
        if(this.modeType && !this.isOwnerForm){
          this.$refs.searchInnerCompany.confirmSelect();
          this.$emit('input',this.$t('proprietor.proprietorModal.title'))
          this.$emit("error");
        }else{
          this.ownerForm.validateFieldsAndScroll({force:true},(err, values) => {
            if (!err) {
              /*if(this.mansionIds.length == 0 && !this.ownerId){
                this.$message.warn(this.$t('proprietor.proprietorModal.projectTip'))
                this.$emit("error");
                return false;
              }*/
              this.fillData(values);
            }else{
              this.$emit("error");
            }
          });
        }
      },
      fillData(data){
        if(data.linkmanVOList != null && data.linkmanVOList.length > 0){
          data.linkmanVOList.forEach(data=>{
            if(data.mansionIds){
              var linkmanMansionDOList = [];
              data.mansionIds.forEach(id=>{
                var linkmanMansionDO = {
                  mansionId:id
                }
                linkmanMansionDOList.push(linkmanMansionDO);
              })
              data["linkmanMansionDOList"] = linkmanMansionDOList;
            }
          })
        }
        // data["type"] = this.isSecond;
        data["ownerMansionDOList"] = this.mansionIds
        if(this.ownerId){
          data["id"] = this.ownerId;
          data["version"] = this.ownerVO.version;
        }
        data["logo"] = this.fileDO.id;
        if(this.ownerId){
          data["ownerMansionDOList"] = null
          this.update(data);
        }else{
          this.save(data);
        }
      },
      save(data){
        insert(data).then(res => {
          if (res.code == 1) {
            let companySortNameCn = this.ownerForm.getFieldValue('companySortNameCn')
            data['companySortNameCn'] = companySortNameCn
            this.$message.success(this.$t('proprietor.proprietorModal.saveSuccessTip'));
            this.$emit("saveSuccess",res.data,data.companyName,data);
          }
        }).finally(()=>{
          this.$emit("error");
        })
      },
      update(data){
        update(data).then(res => {
          if (res.code == 1) {
            this.$message.success(this.$t('proprietor.proprietorModal.updateSuccessTip'));
            this.$emit("saveSuccess");
          }
        }).finally(()=>{
          this.$emit("error");
        })
      }
    }
  }
</script>

<style scoped lang="less">
  #addProprietor{
    .project_div{
      margin-top:20px;
      .project_top{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .expandTitleRow{
          display: flex;
          align-items: center;
        }
        .mul_select{
          font-size: 12px;
          color: #bebebe;
          padding-left: 10px;
        }
        .required{
          color: #fa6361;
          font-size: 14px;
          padding-top: 6px;
          padding-left: 5px;
        }
        .circleYellow{
          width: 12px;
          height: 12px;
          background: #FABE00;
          border-radius: 50%;
          margin-right: 10px;
        }
        .expandTitle{
          font-size: 14px;
          color: #333333;
        }
      }
      .project_item_div{
        margin-top: 5px;
        background: rgba(248,249,251,0.62);
        border-radius: 4px;
        padding:15px;
        .empty_div{
          padding-top: 10px;
          padding-bottom: 10px;
        }
        .project_header{
          color:#999999;
          font-size: 12px;

        }
        .project_item{
          display: flex;
          align-items: center;
          margin-top: 8px;
          .project_name{
            color: #333333;
            font-size: 12px;
          }
          /deep/ .ant-select-selection-selected-value{
            color:#fabe00;
          }
        }
      }
    }
    .expandMoreBtn{
      background: #E8E8E8;
      border: 1px solid #DFDFDF;
      border-radius: 2px;
      height: 25px;
      display: inline-block;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
      cursor:pointer;
      margin-bottom: 5px;
      margin-top: 20px;
      .expandIcon{
        font-size: 12px;
      }
      .expandMoreText{
        display: inline;
        margin-left: 5px;
        font-size: 12px;
        color: #666666;
      }
    }
    .expandDiv{
      margin-top: 20px;
      .expandMoreDiv{
        padding: 20px 10px 0px 10px;
        background: #F2F4F6;
        border-radius: 2px;
        position: relative;
      }
      .closeExpandBtn{
        position: absolute;
        right: 0px;
        top:0px;
        width: 24px;
        height: 24px;
        border-radius:2px;
        background: #D3D3D3;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        .closeIcon{
          font-size: 14px;
          color: #FFFFFF;
        }
      }
      .expandTitleRow{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 5px;
        .circleYellow{
          width: 12px;
          height: 12px;
          background: #FABE00;
          border-radius: 50%;
          margin-right: 10px;
        }
        .expandTitle{
          font-size: 14px;
          color: #333333;
        }
      }
    }
    .formDiv{
      background: rgba(248,249,251,0.62);
      border-radius: 0 0 4px 4px;
      padding: 20px 20px 0 20px;
      margin-bottom: 20px;
    }
    .addProjectBtn{
      position: absolute;
      right: 0px;
      top:35px;
      width: 20px;
      height: 16px;
      border: 1px solid #FABE00;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .addIcon{
        font-size: 12px;
        color: #FABE00;
      }
    }
    .selectedClass{
      width: 90px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #FABE00;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      color: #333333;
    }
    .unselectClass{
      width: 90px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      cursor: pointer;
      background: #FFFFFF;
      border: 1px solid #EAEAEA;
      font-size: 12px;
      color: #999999;
    }
    .uploadDiv{
      margin-top:4px;
      width: 90px;
      height: 90px;
      background: #E3E3E3;
      border: 1px solid #D3D3D3;
      border-radius: 4px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      .addIcon{
        font-size: 18px;
        color: #454341;
      }
    }
    .titleRow{
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 20px;
      margin-bottom: 5px;
      .circle{
        margin-left: 12px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #FABE00;
      }
      .titleText{
        padding: 0 10px;
        color: #333333;
        font-size: 14px;
      }
    }
    .labelText{
      font-size: 12px;
      color: #999999;
      margin-left: 4px;
    }
    .deleteBtn{
      margin-top: 10px;
      margin-left: 10px;
      cursor: pointer;
      .delIcon{
        font-size: 18px;
      }
    }
    .addContactBtn{
      width: 20px;
      height: 16px;
      border: 1px solid #FABE00;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin-bottom: 18px;
      .addIcon{
        font-size: 12px;
        color: #FABE00;
      }
    }
  }
</style>
<style>
  #addProprietor .expandMoreDiv .ant-select-selection__choice__content{
    max-width: 65px !important;
  }
  #addProprietor .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #FABE00;
    border-color: #FABE00;
  }
</style>